import { create } from "zustand"

type WhatsNewState = {
  /**
   * Set by a real sign-in only, so the popup shows right after login and not on a
   * refresh or a restored session. Kept in memory on purpose: a reload clears it.
   */
  showAfterLogin: boolean
  requestAfterLogin: () => void
  clearAfterLogin: () => void
}

export const useWhatsNewStore = create<WhatsNewState>((set) => ({
  showAfterLogin: false,
  requestAfterLogin: () => set({ showAfterLogin: true }),
  clearAfterLogin: () => set({ showAfterLogin: false }),
}))
